import React from 'react';
import { Spin } from 'antd';

export default ({ error }) => {
  if (error) {
    return <div>抱歉，页面发生错误！</div>;
  } else {
    return <Spin />;
  }
};



// WEBPACK FOOTER //
// ./src/layout/Loading.js